export enum ITenantDetailsPageTabs {
  Overview = 'overview',
}
